import type { ElementType } from "react";
import styled from "styled-components";
import themeGet from "@styled-system/theme-get";
import { Box } from "orcs-design-system";

/**
 * Inline label for tree row anchors. Use a span (not P) inside <a> so copy-link
 * and modifier-click behave correctly in browsers.
 */
const treeRowLinkLabelBase: ElementType = Box ?? "span";

const TreeRowLinkLabel = styled(treeRowLinkLabelBase).attrs({
  as: "span",
})<{
  $useSubTextColor?: boolean | undefined;
  $fillRow?: boolean | undefined;
}>`
  z-index: 2;
  transition: ${themeGet("transition.transitionDefault")};
  font-weight: ${themeGet("fontWeights.1")};
  font-size: ${themeGet("fontSizes.1")};
  color: ${(props) =>
    props.$useSubTextColor ? themeGet("colors.subText")(props) : "inherit"};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  word-break: ${(props) => (props.$fillRow ? "break-word" : "normal")};
  flex: ${(props) => (props.$fillRow ? "1" : "0 1 auto")};
`;

export default TreeRowLinkLabel;
